import * as React from 'react';
import axios from 'axios';
import * as _ from 'lodash';
import authService from './api-authorization/AuthorizeService';

interface NewJobMatchingJobs {
    jobs: MatchingJobs[];
    loading: boolean;
}

interface MatchingJobs {
    id: number;
    customer: string;
    siteAddress: string;
    items: MatchingJobItems[];
    showDetail: boolean;
}

interface MatchingJobItems {
    id: number;
    item: string;
    quantity: number;
    status: string;
}

interface NewJobMatchProps {
    currentStep: number;
    jobAddress: JobAddress;
    goingNext: boolean;
    goPrev(): void;
    goNext(): void;
}

interface JobAddress {
    manualStreetName: string;
    manualSuburb: string;
    manualState: string;
    manualPostCode: string;
    siteAddressExists: boolean;
    siteAddress: string;
}

export default class JobMatchingJobs extends React.Component<NewJobMatchProps, NewJobMatchingJobs> {
    constructor(props: NewJobMatchProps) {
        super(props);

        this.state = {
            jobs: [],
            loading: true
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        let manualSiteAddress = this.props.jobAddress.manualStreetName + ", " + this.props.jobAddress.manualSuburb + " " + this.props.jobAddress.manualState + " " + this.props.jobAddress.manualPostCode;
        var siteAddress = this.props.jobAddress.siteAddressExists ? this.props.jobAddress.siteAddress : manualSiteAddress;
        if (siteAddress) {
            const token = await authService.getAccessToken();
            const user = await authService.getUser();

            axios.get('api/Job/GetMatchingJobs?SubId=' + user.sub + '&siteAddress=' + encodeURIComponent(siteAddress), {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                this.setState({ jobs: res.data, loading: false });
                if (res.data.length == 0) {
                    //skip this step
                    if (this.props.goingNext) {
                        this.validate();
                    } else {
                        this.prev();
                    }

                }
            });
        } else {
            //price only jobs don't have a site address
            if (this.props.goingNext) {
                this.validate();
            } else {
                this.prev();
            }
        }
    }

    prev = () => {
        this.props.goPrev();
    }

    validate = () => {
        this.props.goNext();
    }

    updateShowDetail = (rowIndex: number, showDetail: boolean) => {
        //update show Detail from False to True and vice versa
        if (showDetail == null) {
            showDetail = true;
        } else {
            showDetail = !showDetail;
        }

        //update the row
        const jobs = this.state.jobs;
        jobs[rowIndex].showDetail = showDetail;

        this.setState({ jobs: jobs });

    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        if (this.props.currentStep !== 2) {
            return null;
        }

        return (
            <div>
                <div className="overflowAuto newJobMatchingJobs__bottomPadding">
                    <table className="table newJobMatchingJobs__tableSize tableColours">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Job Number</th>
                                <th>Customer</th>
                                <th>Site Address</th>
                                <th></th>
                            </tr>
                        </thead>
                        {this.state.jobs.map((job, index) =>
                            <tbody key={job.id}>
                                <tr >

                                    <td><button type="button" className="btn btn-default btn-sm" onClick={() => this.updateShowDetail(index, job.showDetail)}><i className={"fas fa-plus" + (job.showDetail ? ' rotate45deg' : '')}></i></button></td>
                                    <td>{job.id}</td>
                                    <td>{job.customer}</td>
                                    <td>{job.siteAddress}</td>
                                    <td>
                                        <a href={"/job/" + job.id} target="_blank">Open</a>
                                    </td>
                                </tr>

                                <tr className={(job.showDetail ? '' : 'row--hidden')}>
                                    <td colSpan={5}>
                                        <table className='table subtable tableColours'>
                                            <thead>
                                                <tr>
                                                    <th>Item</th>
                                                    <th>Quantity</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            {job.items.map((item, index) =>
                                                <tbody key={item.id}>
                                                    <tr>
                                                        <td>{item.item}</td>
                                                        <td>{item.quantity}</td>
                                                        <td>{item.status}</td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>

                                    </td>
                                </tr>


                            </tbody>
                        )}
                    </table>
                </div>
                <div>
                    <div className="input-group-parent">
                        <button className="defaultbutton" onClick={this.prev} type="button">Prev</button>
                    </div>
                    <div className="input-group-parent">
                        <div className="colAlignRight">
                            <button className="defaultbutton--save" onClick={this.validate} type="button">Next</button>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}